import { AttorneySummaryReport } from "@/components/features/reports/Attorneys/AttorneySummaryReport";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  attorneySummaryQueryOptions,
  useUpdateAttorneyReportDefaultRole,
} from "@/lib/data/react-query/reports/reports-attorney-summary";
import type { AttorneySummaryFilters } from "@/lib/data/requests/reports/reports-attorney-summary";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { format } from "date-fns";
import { useState } from "react";

export const Route = createFileRoute("/_auth/reports/attorney-summary")({
  component: RouteComponent,
});
function defaultFilters(): AttorneySummaryFilters {
  return {
    asOfDate: format(new Date(), "yyyy-MM-dd"),
    period: "month-to-date",
    litigation: "all",
  };
}
function RouteComponent() {
  const { hasPagePermission } = useUser();
  const canView =
    hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsRoleAssignments) &&
    hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsSettlements);
  const [filters, setFilters] = useState(defaultFilters);
  const query = useQuery({
    ...attorneySummaryQueryOptions(filters),
    enabled: canView,
  });
  const pin = useUpdateAttorneyReportDefaultRole();
  if (!canView) return <GlobalNotAuthorized />;
  return (
    <AttorneySummaryReport
      filters={filters}
      report={query.data}
      isLoading={query.isLoading}
      isFetching={query.isFetching}
      isError={query.isError}
      isPinning={pin.isPending}
      onPinRole={(roleId) => {
        const data = query.data?.data;
        if (
          data?.pinnedRoleId === undefined ||
          data.firmDateModified === undefined
        )
          return;
        pin.mutate({
          roleId,
          expectedPinnedRoleId: data.pinnedRoleId,
          firmDateModified: data.firmDateModified,
        });
      }}
      onFilters={setFilters}
      onReset={() => {
        setFilters(defaultFilters());
      }}
      onRetry={() => {
        void query.refetch();
      }}
    />
  );
}
